import { render, staticRenderFns } from "./DataClean.vue?vue&type=template&id=37fe526a&scoped=true&"
import script from "./DataClean.vue?vue&type=script&lang=ts&"
export * from "./DataClean.vue?vue&type=script&lang=ts&"
import style0 from "./DataClean.vue?vue&type=style&index=0&id=37fe526a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37fe526a",
  null
  
)

export default component.exports